import React, { Component } from "react";
import RoundButton from "../../components/RoundButton";
import { Editor, EditorState, RichUtils, Modifier } from "draft-js";
import EditorToolbarPortal from "../editorToolBar/EditorToolbarPortal";
import EditorToolbar from "../editorToolBar/EditorToolbar";
import themes from "../../themes";
import "../../../node_modules/draft-js/dist/Draft.css";
import { colorStyleMap } from  "../../draftUtilities"


export default class DraftEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty()
    };
    this.input = React.createRef();
    this.onChange = editorState => this.setState({editorState}); ;
  };
  componentDidMount = async () => {
    const { match, utils } = this.props;

    let result = await utils.fb.readText(
      match.params.book,
      match.params.chapter,
      match.params.section
    );
    let newState = utils.draft.rawToText(this.state, result.text);
    this.setState({editorState: newState})
  };
  componentWillUnmount = () => {
    this.setState({ editorState: null });
  }
  
  focus = () => this.input.current.focus();
  saveText = (bookID, chapter, section) => {
    const { utils } = this.props;
    let data = utils.draft.textToRaw(this.state);
    utils.fb.saveText(bookID, chapter, section, data);
  };
  handleKeyCommand = command => {
    const { editorState } = this.state;
    const { match } = this.props;
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    if (command === "myeditor-save") {
      this.saveText(
        match.params.book,
        match.params.chapter,
        match.params.section);
      return true;
    }
    return false;
  };
  toggleBlockType = blockType => {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  };
  toggleInlineStyle = inlineStyle => {
    this.onChange(
      RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle)
    );
  };

  toggleColor = toggledColor => {
  
    const { editorState } = this.state
    const selection = editorState.getSelection()
    // Turn off all active colors.
    // const nextContentState = Object.keys(colorStyleMap).reduce(
    //   (contentState, color) => {

    //     return Modifier.removeInlineStyle(contentState, selection, color);
    //   },
    //   editorState.getCurrentContent()
    // );

    // let nextEditorState = EditorState.push(
    //   editorState,
    //   nextContentState,
    //   "change-inline-style"
    // );

    const currentStyle = editorState.getCurrentInlineStyle();

    // if (selection.isCollapsed()) {
    //   nextEditorState = currentStyle.reduce((state, color) => {
    //     return RichUtils.toggleInlineStyle(state, color);
    //   }, nextEditorState);
    // }
    console.log(currentStyle)
    if (!currentStyle.has(toggledColor)) {
        this.onChange(RichUtils.toggleInlineStyle(
        editorState,
        "red"
      ));
    }
    
  };
  render = () => {
    const { match, theme, utils, author } = this.props;
    const backC = theme === "dark"? themes[0].color1 : themes[1].color1
    return (
      <div
        style={{
          fontSize: 32,
          width: "100vw",
          maxWidth: "1120px",
          borderRadius: "15px 15px 0px 0px",
          padding: "10px",
          position: "relative",
          overflowY: "scroll",
          left: "200px",
          backgroundColor: backC,
          zIndex: 2
        }}
        //  onClick={() => {
        //    this.focus()}}
        >
        <Editor
          placeholder="..."
          key={match.params.section}
          readOnly={!author}
          handleKeyCommand={this.handleKeyCommand}
          editorState={this.state.editorState}
          onChange={this.onChange}
          ref={this.input}
        />
        { author && <EditorToolbarPortal>
          <EditorToolbar
            toggleInlineStyle={this.toggleInlineStyle}
            toggleBlockType={this.toggleBlockType}
            toggleColor={this.toggleColor}
            editorState={this.state.editorState}
            match={match}
            theme={theme}
            utils={utils}
            saveText={this.saveText.bind(this)}
          />
        </EditorToolbarPortal> }
        
      </div>
    );
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/editor/Editor.js